import { Component, ElementRef, forwardRef, Input, Output, EventEmitter, OnInit, ViewChild, Renderer2, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { ClipboardService } from 'ngx-clipboard';

type InputSize = 'small' | 'medium';
type InputBorder = 'bottom' | 'full';

const iconClasses = {
  passwordVisible: 'icon-smash_open_eye',
  passwordHidden: 'icon-smash_close_eye',
  copy: "icon-smash_copy",
  tooltip: "icon-smash_informations",
};

const defaultInputSize = 'medium';
const defaultBorderStyle = 'bottom';

@Component({
  selector: 'app-smash-fake-password',
  templateUrl: './smash-fake-password.component.html',
  styleUrls: ['./smash-fake-password.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SmashFakePasswordComponent),
      multi: true
    },
  ]
})
export class SmashFakePasswordComponent implements OnInit, AfterContentChecked, ControlValueAccessor {

  @Input() size: InputSize = defaultInputSize;
  @Input() borderStyle: InputBorder = defaultBorderStyle;
  @Input() placeholder = '';
  @Input() disabled = false;
  @Input() readonly = false;
  @Input() processing = false;
  @Input() formControlName = '';

  /* Handle error style */
  @Input() error: boolean;
  /* Max caracter length for input */
  @Input() maxLength: number;
  /* Tooltip */
  @Input() tooltipContent: string;

  /* Maybe to remove */
  @Input() max: number;
  @Input('value') _value: any;

  /* Event on value change */
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  /* Event went value is copied */
  @Output() copy: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('input') input: ElementRef;


  /* Border classes for input */
  inputBorderClasses = {
    full: 'border-full',
    bottom: 'border-bottom',
  }

  /* Input is focused or not */
  inputFocused = false;
  inputClass: string;
  iconClass: string;

  passwordVisible = false;
  tooltipVisible = false;

  defaultTooltipDirection = 'right';

  constructor(private ref: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.iconClass = iconClasses.passwordHidden;
    this.inputClass = 'hide-chars';
    if (this.tooltipContent) {
      this.iconClass = iconClasses.tooltip;
    }
  }

  ngAfterContentChecked(): void {
    this.ref.detectChanges();
  }

  togglePassword() {
    if (!this.disabled) {
      this.passwordVisible = !this.passwordVisible;
      if (this.passwordVisible) {
        this.iconClass = iconClasses.passwordVisible;
        this.inputClass = 'show-chars';
      } else {
        this.iconClass = iconClasses.passwordHidden;
        this.inputClass = 'hide-chars';
      }
    }
  }

  toggleIcon() {
    this.togglePassword();
  }

  /* Called when input is focused */
  onInputFocus() {
    this.inputFocused = true;
  }

  /* Called when input is out focused */
  onInputFocusOut() {
    this.inputFocused = false;
  }

  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
    this.valueChange.emit(val);
  }

  /* ControlValueAccessor specifications */
  onChange: any = () => { };
  onTouched: any = () => { };
  validateFn: any = () => { };

  get value() {
    return this._value;
  }

  writeValue(value: any) {
    if (value) {
      this.value = value;
    } else {
      this.value = null;
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  focus() {
    this.input.nativeElement.focus();
  }
}
